import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function CessioneCrediti() {
  const [form, setForm] = useState({ nome: '', cognome: '', email: '', telefono: '', azienda: '', importo_credito: '', tipo_credito: '', messaggio: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email) { toast.error('Inserisci la tua email'); return; }
    setLoading(true);
    try {
      await axios.post('/api/cessione/richiesta', form);
      toast.success('Richiesta inviata con successo! Ti contatteremo entro 24 ore.');
      setSent(true);
    } catch { toast.error('Errore nell\'invio. Riprova.'); }
    setLoading(false);
  };

  const faqs = [
    { q: 'Quali crediti fiscali posso cedere?', a: 'Puoi cedere crediti derivanti da Superbonus 110%, Ecobonus, Sismabonus, Bonus Ristrutturazioni e Bonus Facciate. Tutti i crediti devono essere regolarmente presenti nel cassetto fiscale.' },
    { q: 'Qual e l\'importo minimo per la cessione?', a: 'L\'importo minimo per la cessione e di €50.000. Per importi inferiori, ti consigliamo di valutare la detrazione diretta in dichiarazione dei redditi.' },
    { q: 'Come funzionano le commissioni?', a: 'Le commissioni sono trasparenti: il cliente (cedente) trattiene l\'75% del valore nominale del credito, l\'acquirente (cessionario) riceve il 20%, e VerificaIncentivi trattiene il 5% come commissione di intermediazione.' },
    { q: 'Quanto tempo richiede il processo?', a: 'Il processo completo richiede mediamente 15-30 giorni lavorativi dalla ricezione di tutta la documentazione necessaria.' },
    { q: 'E sicuro cedere i crediti?', a: 'Assolutamente si. Operiamo nel pieno rispetto della normativa vigente. Tutti i crediti vengono verificati prima della cessione e la transazione avviene tramite la piattaforma dell\'Agenzia delle Entrate.' },
    { q: 'Quali documenti servono?', a: 'Servono: visura camerale aggiornata, asseverazione tecnica, visto di conformita, documentazione dell\'intervento, e accesso al cassetto fiscale per la verifica del credito.' },
  ];

  return (
    <div className="fade-in">
      {/* Hero */}
      <section className="landing-hero">
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ maxWidth: 700 }}>
            <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', padding: '6px 16px', borderRadius: 20, fontSize: 13, marginBottom: 16 }}>
              Servizio Cessione Crediti Fiscali Edilizi
            </div>
            <h1 style={{ fontSize: 42, fontWeight: 800, marginBottom: 16, lineHeight: 1.2 }}>
              Monetizza i Tuoi Crediti Fiscali Edilizi
            </h1>
            <p style={{ fontSize: 18, opacity: 0.9, marginBottom: 24 }}>
              Hai crediti da Superbonus, Ecobonus o Sismabonus? Trasformali in liquidita con il nostro servizio di cessione. Commissioni trasparenti, processo sicuro e veloce.
            </p>
            <a href="#form-cessione" className="btn btn-lg btn-green">Richiedi Valutazione Gratuita</a>
          </div>
        </div>
      </section>

      {/* Commissioni */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Commissioni Trasparenti</h2>
          <p className="section-subtitle">Nessun costo nascosto. Sai esattamente quanto riceverai.</p>
          <div className="commission-grid">
            <div className="commission-box green">
              <div className="percent">75%</div>
              <h3 style={{ marginTop: 12 }}>Cliente (Cedente)</h3>
              <p style={{ color: '#6b7280', fontSize: 14, marginTop: 8 }}>L'importo che trattieni dalla cessione del tuo credito fiscale</p>
            </div>
            <div className="commission-box blue">
              <div className="percent">20%</div>
              <h3 style={{ marginTop: 12 }}>Acquirente (Cessionario)</h3>
              <p style={{ color: '#6b7280', fontSize: 14, marginTop: 8 }}>Lo sconto applicato all'acquirente del credito fiscale</p>
            </div>
            <div className="commission-box gray">
              <div className="percent">5%</div>
              <h3 style={{ marginTop: 12 }}>VerificaIncentivi</h3>
              <p style={{ color: '#6b7280', fontSize: 14, marginTop: 8 }}>La nostra commissione di intermediazione per il servizio</p>
            </div>
          </div>
          <p style={{ textAlign: 'center', marginTop: 20, color: '#6b7280', fontSize: 14 }}>
            Importo minimo per la cessione: <strong>€50.000</strong>
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Testimonianze</h2>
          <div className="grid-3">
            <div className="testimonial">
              <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
              <div className="quote">"Ho ceduto €120.000 di crediti Superbonus in meno di 20 giorni. Processo semplice e trasparente, ho ricevuto €96.000 sul conto."</div>
              <div className="author">Mario R.</div>
              <div className="role">Imprenditore Edile, Milano</div>
            </div>
            <div className="testimonial">
              <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
              <div className="quote">"Come commercialista, ho consigliato VerificaIncentivi a diversi clienti per la cessione dei crediti. Servizio affidabile e professionale."</div>
              <div className="author">Laura C.</div>
              <div className="role">Commercialista, Roma</div>
            </div>
            <div className="testimonial">
              <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
              <div className="quote">"Avevo crediti Ecobonus bloccati da mesi. Grazie a VerificaIncentivi li ho monetizzati rapidamente. Commissioni oneste."</div>
              <div className="author">Giuseppe P.</div>
              <div className="role">Titolare Impresa Edile, Catania</div>
            </div>
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="section" style={{ background: 'white' }} id="form-cessione">
        <div className="container">
          <div style={{ maxWidth: 600, margin: '0 auto' }}>
            <h2 className="section-title">Richiedi una Valutazione Gratuita</h2>
            <p className="section-subtitle">Compila il form e ti contatteremo entro 24 ore per valutare i tuoi crediti</p>

            {sent ? (
              <div className="card" style={{ textAlign: 'center', padding: 40 }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</div>
                <h3 style={{ color: '#16a34a', marginBottom: 8 }}>Richiesta Inviata!</h3>
                <p style={{ color: '#6b7280' }}>Ti contatteremo entro 24 ore per valutare i tuoi crediti fiscali.</p>
                <p style={{ marginTop: 16 }}>Nel frattempo, contattaci su <a href="https://wa.me/393484932900" target="_blank" rel="noopener noreferrer">WhatsApp</a></p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="card">
                <div className="grid-2">
                  <div className="form-group">
                    <label>Nome</label>
                    <input value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} placeholder="Il tuo nome" />
                  </div>
                  <div className="form-group">
                    <label>Cognome</label>
                    <input value={form.cognome} onChange={e => setForm({...form, cognome: e.target.value})} placeholder="Il tuo cognome" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="email@azienda.it" required />
                </div>
                <div className="grid-2">
                  <div className="form-group">
                    <label>Telefono</label>
                    <input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="+39..." />
                  </div>
                  <div className="form-group">
                    <label>Azienda</label>
                    <input value={form.azienda} onChange={e => setForm({...form, azienda: e.target.value})} placeholder="Nome azienda" />
                  </div>
                </div>
                <div className="grid-2">
                  <div className="form-group">
                    <label>Tipo di Credito</label>
                    <select value={form.tipo_credito} onChange={e => setForm({...form, tipo_credito: e.target.value})}>
                      <option value="">Seleziona...</option>
                      <option value="Superbonus 110%">Superbonus 110%</option>
                      <option value="Ecobonus">Ecobonus</option>
                      <option value="Sismabonus">Sismabonus</option>
                      <option value="Bonus Ristrutturazioni">Bonus Ristrutturazioni</option>
                      <option value="Bonus Facciate">Bonus Facciate</option>
                      <option value="Altro">Altro</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Importo Credito (€)</label>
                    <input value={form.importo_credito} onChange={e => setForm({...form, importo_credito: e.target.value})} placeholder="es. 100.000" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Messaggio</label>
                  <textarea rows={3} value={form.messaggio} onChange={e => setForm({...form, messaggio: e.target.value})} placeholder="Descrivi brevemente la tua situazione..." />
                </div>
                <button type="submit" className="btn btn-lg btn-green" style={{ width: '100%' }} disabled={loading}>
                  {loading ? 'Invio in corso...' : 'Invia Richiesta Gratuita'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <div className="container" style={{ maxWidth: 700 }}>
          <h2 className="section-title">Domande Frequenti</h2>
          {faqs.map((faq, i) => (
            <div key={i} className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                {faq.q}
                <span>{openFaq === i ? '\u2212' : '+'}</span>
              </div>
              {openFaq === i && <div className="faq-answer">{faq.a}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
